<script>
import TimeMixin from '@/mixins/general/TimeMixin.vue'

export default {
  name: 'SurescriptDoctorMixin',
  mixins: [TimeMixin],
  data () {
    return {
      arrayStatusTex: {
        'active': 'Activated',
        'deactive': 'Deactivated'
      }
    }
  },
  computed: {},
  watch: {},
  methods: {
    getTitleSurescriptDoctor (doctor) {
      if (doctor.surescriptRequestActive && doctor.surescriptRequestActive.eRxStatus === 'user_request') {
        return `User request enable e-Rx on ${this.formatTime(doctor.surescriptRequestActive.eRxStatus)}`
      }
      if (doctor && doctor.surescriptDoctor && this.getStatusSurescriptDoctor(doctor) !== 'Deactivated') {
        return `SPI: ${doctor.surescriptDoctor.SPI}, ServiceLevels: [${(doctor.surescriptDoctor.ServiceLevels ? doctor.surescriptDoctor.ServiceLevels : []).join(',')}]`
      }
      return ``
    },
    getTitleEPCS (doctor) {
      if (doctor.surescriptRequestActive && doctor.surescriptRequestActive.ePcsStatus === 'user_request') {
        return `User request enable EPCS on ${this.formatTime(doctor.surescriptRequestActive.ePcsDate)}`
      }
      return doctor.surescriptRequestActive ? this.arrayStatusTex[doctor.surescriptRequestActive.ePcsStatus] : 'Deactivated'
    },
    getEPCSStatus (doctor) {
      if (doctor.surescriptRequestActive && doctor.surescriptRequestActive.ePcsStatus === 'user_request') {
        return `User Request`
      }
      if (doctor.surescriptRequestActive && doctor.surescriptRequestActive.ePcsStatus === 'active') {
        return 'Activated'
        // if (doctor.surescriptDoctor && doctor.surescriptDoctor.controlledSubstanceDate) {
        //   return this.formatTime(doctor.surescriptDoctor.controlledSubstanceDate)
        // }
      }
      return doctor.surescriptRequestActive ? this.arrayStatusTex[doctor.surescriptRequestActive.ePcsStatus] : 'Deactivated'
    },
    getStatusSurescriptDoctor (doctor) {
      if (doctor.surescriptRequestActive && doctor.surescriptRequestActive.eRxStatus === 'user_request') {
        return `User Request`
      }
      if (doctor.surescriptDoctor && doctor.surescriptDoctor.SPI && doctor.surescriptDoctor.statusDoctor === 'Active') {
        return 'Activated'
      }
      if (doctor.surescriptDoctor && doctor.surescriptDoctor.SPI && doctor.surescriptDoctor.statusDoctor === 'Deactive') {
        return 'Deactivated'
      }
      return 'Deactivated'
    }
  }

}
</script>
